import PropTypes from 'prop-types';

export const QuotePartnerPropTypes = {
  PartnerNumber: PropTypes.string
};

export const QuoteLoadingPropTypes = {
  LoadingCode: PropTypes.string,
  LoadingName: PropTypes.string,
  LoadingBase: PropTypes.number,
  LoadingStampDuty: PropTypes.number,
  LoadingGst: PropTypes.number,
  LoadingNo: PropTypes.number,
  WebDisplayValue: PropTypes.bool,
  PremiumFreeValue: PropTypes.number
};

export const QuoteOptionalCoverPropTypes = {
  ProductCode: PropTypes.string,
  PlanNumber: PropTypes.number,
  CombinationGroupId: PropTypes.number,
  ExcessCode: PropTypes.string,
  Excess: PropTypes.number,
  LevelOfCoverCode: PropTypes.string,
  LevelOfCover: PropTypes.number,
  AnnualBenefitLimitCode: PropTypes.string,
  AnnualBenefitLimit: PropTypes.number,
  BasePremium: PropTypes.number,
  StampDuty: PropTypes.number,
  Gst: PropTypes.number,
  FixedTerm: PropTypes.number,
  IsBenefitSchedulePlan: PropTypes.number,
  PaymentFrequencyCode: PropTypes.string,
  TotalOptionalCoverAmount: PropTypes.number,
  TotalOptionalCoverLoadingAmount: PropTypes.number,
  LessFreeMonthAmount: PropTypes.number,
  Loadings: PropTypes.arrayOf(PropTypes.shape(QuoteLoadingPropTypes))
};

export const QuotePremiumPropTypes = {
  ProductCode: PropTypes.string,
  PlanNumber: PropTypes.number,
  CombinationGroupId: PropTypes.number,
  PaymentFrequencyCode: PropTypes.string,
  ExcessCode: PropTypes.string,
  Excess: PropTypes.number,
  LevelOfCoverCode: PropTypes.string,
  LevelOfCover: PropTypes.number,
  AnnualBenefitLimitCode: PropTypes.string,
  AnnualBenefitLimit: PropTypes.number,
  BasePremium: PropTypes.number,
  StampDuty: PropTypes.number,
  Gst: PropTypes.number,
  FixedTerm: PropTypes.number,
  IsBenefitSchedulePlan: PropTypes.number,
  TotalPremiumAmount: PropTypes.number,
  TotalLoadingAmount: PropTypes.number,
  LessFreeMonthAmount: PropTypes.number,
  Loadings: PropTypes.arrayOf(PropTypes.shape(QuoteLoadingPropTypes)),
  OptionalCovers: PropTypes.arrayOf(PropTypes.shape(QuoteOptionalCoverPropTypes))
};

export const QuoteProductPropTypes = {
  ProductCode: PropTypes.string,
  ProductName: PropTypes.string
};

export const QuoteLevelOfCoverPropTypes = {
  LevelOfCoverCode: PropTypes.string,
  LevelOfCover: PropTypes.number
};

export const QuoteExcessLevelPropTypes = {
  ExcessCode: PropTypes.string,
  Excess: PropTypes.number
};

export const QuoteAnnualBenefitLimitPropTypes = {
  AnnualBenefitLimitCode: PropTypes.string,
  AnnualBenefitLimit: PropTypes.number
};

export const QuoteFixedTermPropTypes = {
  Term: PropTypes.number
};

export const QuotePaymentFrequencyPropTypes = {
  PaymentFrequencyCode: PropTypes.string,
  PaymentFrequency: PropTypes.string
};

export const QuotePetPropTypes = {
  PetID: PropTypes.number,
  PetName: PropTypes.string,
  PetOrderNumber: PropTypes.number,
  Partners: PropTypes.arrayOf(PropTypes.shape(QuotePartnerPropTypes)),
  Premiums: PropTypes.arrayOf(PropTypes.shape(QuotePremiumPropTypes)),
  Products: PropTypes.arrayOf(PropTypes.shape(QuoteProductPropTypes)),
  LevelsOfCover: PropTypes.arrayOf(PropTypes.shape(QuoteLevelOfCoverPropTypes)),
  ExcessLevels: PropTypes.arrayOf(PropTypes.shape(QuoteExcessLevelPropTypes)),
  AnnualBenefitLimits: PropTypes.arrayOf(PropTypes.shape(QuoteAnnualBenefitLimitPropTypes)),
  FixedTerms: PropTypes.arrayOf(PropTypes.shape(QuoteFixedTermPropTypes)),
  PaymentFrequencies: PropTypes.arrayOf(PropTypes.shape(QuotePaymentFrequencyPropTypes))
};

export const QuoteDetailPropTypes = {
  OnlineQuoteNumber: PropTypes.number,
  QuoteReferenceNumber: PropTypes.string,
  StartDate: PropTypes.string,
  EndDate: PropTypes.string,
  Web: PropTypes.bool,
  Telephone: PropTypes.bool,
  FaceToFace: PropTypes.bool,
  Pets: PropTypes.arrayOf(PropTypes.shape(QuotePetPropTypes))
};
